import * as React from 'react';
import styled from 'styled-components';

const Loader = styled.div`
  text-align:center;
  font-size:25px;
`;

const spinner = () => {
  return (<Loader>Loading....</Loader >);
};

export default spinner;